import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler,
} from 'chart.js';
import { Bar, Line, Pie } from 'react-chartjs-2';
import './FinancialChart.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler // Necessário para usar fill: true em gráficos de linha
);

const FinancialChart = ({ type, data, title, className = '' }) => {
  // maintainAspectRatio: false → o canvas respeita a altura do container CSS
  const baseOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: { boxWidth: 12, padding: 10, font: { size: 11 } },
      },
      title: {
        display: !!title,
        text: title,
        font: { size: 13, weight: '600' },
        padding: { bottom: 8 },
      },
    },
    scales: type === 'bar' || type === 'line'
      ? {
          x: { grid: { display: false }, ticks: { font: { size: 11 } } },
          y: { grid: { color: 'rgba(0,0,0,0.04)' }, ticks: { font: { size: 11 } } },
        }
      : undefined,
  };

  const renderChart = () => {
    switch (type) {
      case 'bar':   return <Bar   options={baseOptions} data={data} />;
      case 'line':  return <Line  options={baseOptions} data={data} />;
      case 'pie':   return <Pie   options={baseOptions} data={data} />;
      default:      return <Bar   options={baseOptions} data={data} />;
    }
  };

  const containerClass = ['chart-container', className].filter(Boolean).join(' ');
  return <div className={containerClass}>{renderChart()}</div>;
};

export default FinancialChart;
